module.exports = __webpack_public_path__ + "img/mideke_dev_white.9c0a11d9.png";